import { connect } from 'react-redux'
import { required } from 'util/validation'
import withFormFields from 'shared/ui/Form/withFormFields'
import { selectAccountIsOnboardingCompleted } from 'selectors/app'
import { selectIsOauthAuthenticatable } from 'ducks/currentUser/selectors'
import { doSaveAndRedirect } from './actions'

import CompanyPageView from './view'

const validators = {
  companyName: required,
  numberOfEmployees: required,
  industry: required,
  companyRole: required,
}

const initialValues = {
  companyName: '',
  numberOfEmployees: null,
  industry: null,
  companyRole: null,
}

const select = state => ({
  initialValues,
  validators,
  isLastStep: selectIsOauthAuthenticatable(state),
  isOnboardingComplete: selectAccountIsOnboardingCompleted(state),
})

const perform = {
  onSave: doSaveAndRedirect,
}

export default connect(select, perform)(withFormFields(CompanyPageView))
